import React, {useEffect, useState} from 'react';
import entityService from "../../Service/EntityService";
import ModalWindow from "../Static/ModalWindow/ModalWindow";
import Loader from "../Static/Loader/Loader";
import s from "./game-page.module.css";
import supportService from "../../Service/SupportService";

const GamePageComponent = () => {
    const [games, setGames] = useState([])
    const [levels, setLevels] = useState(null)
    const [tasks, setTasks] = useState(null)
    const [logGames, setLogGames] = useState(null)
    const [additionalTasks, setAdditionalTasks] = useState(null)
    const [isLoad, setIsLoad] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [selectGame, setSelectGame] = useState(null)

    useEffect(()=>{
        init()
    },[])

    const init = async ()=>{
        setIsLoad(false)
        try{
            await loadLevel()
            await loadGames()
            await loadTasks()
            await loadAdditionalTasks()
            await loadLogGames()
        } catch(error){
            console.log(error)
            setErrorMessage(error)
        } finally{
            setIsLoad(true)
        }
    }

    const gameEntityName = "game"
    const levelEntityName = "level"
    const taskEntityName = "task"
    const additionalTaskEntityName = "additional_task"
    const logGameEntityName = "log_game"

    const getGameById = (gameId) => {
        return games.find((game) => game.id === gameId)
    }

    const loadLevel = async () => {
        const result = await entityService.getAll(levelEntityName)
        setLevels(result)
    }

    const loadLogGames = async () => {
        const result = await entityService.getAll(logGameEntityName)
        setLogGames(result)
    }

    const loadGames = async () => {
        const resultGames = await entityService.getAll(gameEntityName)
        setGames(resultGames)
        const gameOpenedId = localStorage.getItem("game")
        const gameOpened = gameOpenedId? resultGames?.find(g=>g.id === gameOpenedId):null
        if (gameOpened){
            return setSelectGame(gameOpened)
        }
        setSelectGame(resultGames.length>0?resultGames[0]:null)
    }

    const loadTasks = async () => {
        const result = await entityService.getAll(taskEntityName)
        setTasks(result)
    }

    const loadAdditionalTasks = async () => {
        const result = await entityService.getAll(additionalTaskEntityName)
        setAdditionalTasks(result)
    }

    const deleteLog = async (logGame)=>{
        await entityService.delete("log_game", logGame.id)
        setLogGames(logGames.filter(l=>l.id !== logGame.id))
    }


    const filterLogGames = selectGame && logGames?.length? logGames.filter(g=>g.gameId === selectGame.id) : []

    const points = [
        // {point:'user', pointName:'Пользователи'},
        {point:'game', pointName:'Игры'},
        {point:'level', pointName:'Локации'},
        {point:'task', pointName:'Задания'},
        {point:'additionalTask', pointName:'Дополнительные задания'},
    ]

    return (
        <div className={s.wrapper}>
            <div className={'btn'} onClick={init}>Обновить</div>
            {isLoad && selectGame && games?.length?
                <select value={selectGame?.id} onChange={e=>setSelectGame(games.find(g=>g.id === e.target.value))}>
                    {
                        games.map((game)=>{
                            return (
                                <option value={game.id} key={"select_game_"+game.id}>{game.title}</option>
                            )
                        })
                    }
                </select>:<></>

            }
            {!filterLogGames?.length?<div>Нет логов</div>:<></>}
            {isLoad && filterLogGames.map((logGame)=>{
                const game = getGameById(logGame.gameId)
                            return (
                                <div key={logGame.id}>
                                    <div className={s.title}>{game?.title??""}</div>
                                    <div>{supportService.getLocalDateTime(new Date(logGame.created), true)} <span className={s.deleteResult} onClick={()=>{
                                       if (window.confirm("Удалить лог?")) {
                                            deleteLog(logGame)
                                       }
                                    }
                                    }>Удалить результат</span></div>
                                    <table className={s.table}>
                                        <tbody>
                                            {logGame.result?.map((resultTeam, index)=>{
                                                return (
                                                    <tr key={logGame.id + index}>
                                                        <td>{resultTeam.team.name}</td>
                                                        <td>{resultTeam.score}</td>
                                                        <td>
                                                            {resultTeam.logs?.map((logItem, index)=>{
                                                                return (<tr key={logGame.id+index}>
                                                                    <td>{supportService.getLocalDateTime(new Date(logItem.created), true)}</td>
                                                                    <td>{levels.find(l=>l.id===logItem.levelId)?.title}</td>
                                                                    <td>{logItem.success?"+":"-"}</td>
                                                                    <td>{logItem.score}</td>
                                                                    <td>{logItem.enteredWords.join(", ")}</td>
                                                                </tr>)
                                                            })}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )
                        })


            }
            {errorMessage && <ModalWindow text={errorMessage} closeWindow={()=>setErrorMessage('')} />}
            {!isLoad &&  <Loader/>}
        </div>
    );
};

export default GamePageComponent;